// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1vItW","header":"Messages_header__2cWA9"};